import script from "./AddCorporateComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCorporateComponent.vue?vue&type=script&setup=true&lang=js"

import "./AddCorporateComponent.vue?vue&type=style&index=0&id=6c4d7d78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c4d7d78"]])

export default __exports__